import React, {useCallback, useEffect, useState} from 'react'
import {Dialog} from "@mui/material";
import {useQuery} from "@tanstack/react-query";
import {AxiosError} from "axios";
import HeaderSpacer from "@/view/layout/HeaderSpacer"
import DialogHeader from "@/view/layout/DialogHeader";
import BottomButton from "@/view/common/component/button/BottomButton";
import GameService from "@/service/GameService";
import GameList from "@/view/game/GameList";
import GameAdd from "@/view/game/GameAdd";
import GameDetail from "@/view/game/GameDetail";
import {GameData} from "@/service/GameService";
import StorageUtil from "@/common/StorageUtil";

const GameView = () => {
    const handleOverlayClick = () => {console.log('close')};
    const handleReturnClick = useCallback(() => {
        initData()
    }, [])

    const handleEditComplete = useCallback(() => {
        initData()
        console.log('handleEditComplete')
    }, [])

    const [open, setOpen] = useState(false)

    const [gameList, setGameList] = useState<GameData[]>([])

    const {refetch: getGameList} = useQuery<GameData[], AxiosError>(
        ['getGameList'],
        () => GameService.getGameList(),
        {
            onSuccess: (v) => setGameList(v ?? []),
        }
    )

    const initData = () => {
        getGameList().catch(console.log)
    }

    useEffect(() => {
        initData()
    }, [])

    return (
        <>
            <div className={'game'}>
                <GameList gameList={gameList} onReturn={handleReturnClick}/>
            </div>

            <BottomButton title='Match 등록' disabled={false} onClick={() => setOpen(true)} main={true} />

            <Dialog fullScreen open={open} onClose={() => setOpen(false)}
                    PaperProps={{
                            sx: {
                                backgroundColor: '#1A1A1A',
                                color: '#24cbaa',
                                padding: 0,

                                /* TextField */
                                '& .MuiOutlinedInput-root': {
                                    color: '#24cbaa',
                                    backgroundColor: '#111',
                                },

                                '& .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#24cbaa',
                                },

                                '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#2fffd7',
                                },

                                '& .MuiInputLabel-root': {
                                    color: '#24cbaa',
                                },

                                '& .MuiSvgIcon-root': {
                                    color: '#24cbaa',
                                }
                            }
                        }}
            >
                <GameAdd onClose={() => setOpen(false)} onReturn={handleReturnClick}/>
            </Dialog>


        </>
    )
}

export default GameView
